import { Component, OnInit, ChangeDetectorRef, Input, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Match, Player, Tornament } from '../Main.Model';

@Component({
    selector: 'app-player-history',
    templateUrl: './player-history.component.html',
    styleUrls: ['./player-history.component.css'],
    standalone: false
})
export class PlayerHistoryComponent implements OnInit {

  //Players: any;
  //Matches: any;
  //Torns: any;
  TotalMatches: number;
  //selectedPlayer: Player;
  //SelectedPlayerID: number = 0;
  singlesHistory: boolean = true;
  doublesHistory: boolean = false;
  MatchList: Match[];
  @ViewChild('HistoryTable') HistoryTable: HTMLTableElement;

  constructor(private ref: ChangeDetectorRef, public DataService: DataService) { }

  FindTornById(tornId):Tornament {
    var TheTorn;
    this.DataService.Torns.forEach(torn => {
      if (torn.id == tornId) {
        TheTorn = torn
      }
    });
    return TheTorn
  }

  async ngOnInit() {
    //get query params and use that to set selected player
    if (!this.DataService.Players) {
      await this.DataService.refreshPlayers();
    }
    if (!this.DataService.Torns) {
        await this.DataService.refreshTorns();
    }
    if (!this.DataService.Matches) {
        await this.DataService.refreshMatches();
    }
    const urlParams = new URLSearchParams(window.location.search);
    const playerIdParam = urlParams.get('id');
    if (playerIdParam) {
      const playerId = parseInt(playerIdParam, 10);
      this.DataService.SelectedPlayer = this.DataService.Players.find((p) => {return p.id === playerId});//maybe try this method:!!!!!!!!!!!!!!!!!!!!!!!
      //this.DataService.SelectedPlayer = this.FunctionService.getPlayerObject(playerId, this.DataService.Players);
    }
    this.MatchList = [];
    if (!this.DataService.SelectedPlayer) {
      this.DataService.SelectedPlayer = new Player();
    }
    //if (this.DataService.SelectedPlayer.id > 0) {
      //this.SelectedPlayerID = this.DataService.SelectedPlayer.id;
      //this.DataService.SelectedPlayer = this.FunctionService.getPlayerObject(this.HmService.TheSelectedPlayerID, this.DataService.Players)
    //}
    
    this.reCalcHistory();
    this.ref.detectChanges(); 
  }

  reCalcHistory() {
    if (this.DataService.Matches) {
      this.DataService.SaveState();
      //this.DataService.Players.sort(function (a, b) { return a.name.localeCompare(b.name) });
      this.DataService.Players.sort((a, b) => {
        if (a.name > b.name) {
          return 1
        }
        if (a.name < b.name) {
          return -1
        }
      });
      //this.backgroundImage = "url(../images/background-15.png";
      //this.backgroundImage = "url(../images/background-15.png";
      //need to create a few extra fields
      for (var m = 0; m < this.DataService.Matches.length; m++) {
          var Match = this.DataService.Matches[m];
          if (Match.player1Name) {
              if (Match.player1Name.indexOf('/') > 0) {
                  Match.doubles = true;
                  var Pair = Match.player1Name.split('/');
                  Match.doublesPlayer1 = Pair[0]
                  Match.doublesPlayer3 = Pair[1]
                  Pair = Match.player2Name.split('/');
                  Match.doublesPlayer2 = Pair[0]
                  Match.doublesPlayer4 = Pair[1]
                  Match.player1Change = Match.newPoints1 - Match.startPoints1;
                  Match.player2Change = Match.newPoints2 - Match.startPoints2;
                  Match.player3Change = Match.newPoints3 - Match.startPoints3;
                  Match.player4Change = Match.newPoints4 - Match.startPoints4;
              } else {
                  Match.player1Change = Match.newPoints1 - Match.startPoints1;
                  Match.player2Change = Match.newPoints2 - Match.startPoints2;
                  Match.singles = true;
              }
              var torn = this.FindTornById(Match.torn)
              Match.tornName = torn.name;
              var player1Score = (Match.ttScore1 + Match.badScore1 + Match.squashScore1 + Match.tScore1);
              var player2Score = (Match.ttScore2 + Match.badScore2 + Match.squashScore2 + Match.tScore2);
              if (player1Score > player2Score) {
                  Match.score1 = "Won " + Match.ttScore1 + "-" + Match.ttScore2 + ", " + Match.badScore1 + "-" + Match.badScore2 + ", " + Match.squashScore1 + "-" + Match.squashScore2 + ", " + Match.tScore1 + "-" + Match.tScore2 + " = (" + player1Score + "-" + player2Score + ")";
                  Match.score2 = "Lost " + Match.ttScore2 + "-" + Match.ttScore1 + ", " + Match.badScore2 + "-" + Match.badScore1 + ", " + Match.squashScore2 + "-" + Match.squashScore1 + ", " + Match.tScore2 + "-" + Match.tScore1 + " = (" + player2Score + "-" + player1Score + ")";
              } else if (player2Score > player1Score) {
                  Match.score1 = "Lost " + Match.ttScore1 + "-" + Match.ttScore2 + ", " + Match.badScore1 + "-" + Match.badScore2 + ", " + Match.squashScore1 + "-" + Match.squashScore2 + ", " + Match.tScore1 + "-" + Match.tScore2 + " = (" + player1Score + "-" + player2Score + ")";
                  Match.score2 = "Won " + Match.ttScore2 + "-" + Match.ttScore1 + ", " + Match.badScore2 + "-" + Match.badScore1 + ", " + Match.squashScore2 + "-" + Match.squashScore1 + ", " + Match.tScore2 + "-" + Match.tScore1 + " = (" + player2Score + "-" + player1Score + ")";
              } else {
                  Match.score1 = '0';
                  Match.score2 = '0';
              }
          } else if (Match.newPoints1 > 0) {//this is for the adjustments that get added in
              Match.player1Change = Match.newPoints1;
              Match.score1 = Match.newPoints1.toString();
              Match.newPoints1 = 0;
              Match.tornName = "Adjustment"
              if (Match.player3 == 0) {
                  Match.singles = true;
              } else {
                  Match.doubles = true;
              }
          }
      }
      this.refreshMatchList(this.DataService.SelectedPlayer.id);
      //this.updateHistoryCount();
    }
  }

  playerChanged(Player) {
    this.DataService.SelectedPlayer = Player;
    //this.DataService.SelectedPlayer.id = Player.id;
    this.refreshMatchList(Player.id);
  }

  refreshMatchList(PlayerId) {
    this.MatchList = [];
    this.DataService.Matches.forEach(match => {
      if (match.player1 == PlayerId || match.player2 == PlayerId || match.player3 == PlayerId || match.player4 == PlayerId) {
        if ((match.singles == true && this.singlesHistory == true) || (match.doubles == true && this.doublesHistory == true)) {
          this.MatchList.push(match);
        }
      }
    });
    this.MatchList.sort((a, b) => {
      if (a.dateOfMatch > b.dateOfMatch) {
        return -1
      }
      if (a.dateOfMatch < b.dateOfMatch) {
        return 1
      }
    });
  }

  ViewPlayerHistory(Player) {
    //this.DataService.SelectedPlayerID = Player;
    this.DataService.SelectedPlayer = this.DataService.Players.find((p) => {return p.id === Player});//maybe try this method:!!!!!!!!!!!!!!!!!!!!!!!
    //this.DataService.SelectedPlayer = this.FunctionService.getPlayerObject(Player, this.DataService.Players);
    this.ref.detectChanges();
  }

  gotoTorn() 
  {

  }

  //updateHistoryCount() {

    //this.DataService.SaveState();
    //setTimeout(function () {
      //var TotalMatches = document.getElementById("HistoryTable")
      //this.TotalMatches = TotalMatches.ariaRowSpan;
        // if (this.HistoryTable) {
        //   this.TotalMatches = this.HistoryTable.rows.length - 1;
        // }
    //}, 1000);
  //}

  

}
